
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon-plus",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 1v13M1 7.5h13","stroke":"currentColor"}})])
          )
        }
      }
    